import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { SETTINGS_SECURITY } from '../../../routes/routes';
import { H3, P3 } from '../../../styles/FontStyles';
import { Button } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import { FlexCenter } from '../../../styles/stylesStyled';

export const Required2FA = () => {
  const { t } = useTranslation('settings');
  return (
    <div>
      <FlexCenter style={{ flexDirection: 'column' }}>
        <H3 mb='20' center>
          {t('email.2fa_required')}
        </H3>
        <P3 mb='40' color={color.colors.neutral500} center>
          {t('email.change_email_text')}
        </P3>
        <Link to={SETTINGS_SECURITY}>
          <Button w='200px' opacity={'true'}>
            {t('email.add_2fa_security')}
          </Button>
        </Link>
      </FlexCenter>
    </div>
  );
};
